// eslint-disable-next-line import/prefer-default-export
export type Step = {
  index: number;
  title: string;
};

export const indicatorSteps: Step[] = [
  {
    index: 0,
    title: "Personal Indicators",
  },
  {
    index: 1,
    title: "Team Indicators",
  },
  {
    index: 2,
    title: "Organisational Indicators",
  },
];

export const indicatorProgressionModalContent = [
  {
    title: "Thank you for mapping your Personal Indicators",
    message: "Your will now rate the Team Indicators for your primary team",
  },
  {
    title: "Thank you for mapping your Team Indicators",
    message: "Your will now rate the Organisation Indicators for your organisation",
  },
];
